
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.5 24a.5.5 0 01-.5-.5V.5a.5.5 0 011 0v23a.5.5 0 01-.5.5z"}}),_c('path',{attrs:{"d":"M23.5 24H.5a.5.5 0 010-1h23a.5.5 0 010 1zM4.25 18.07a2.24 2.24 0 112.24-2.24 2.25 2.25 0 01-2.24 2.24zm0-3.49a1.24 1.24 0 101.24 1.25 1.25 1.25 0 00-1.24-1.25zm5.22-2.03a2.24 2.24 0 112.24-2.24 2.25 2.25 0 01-2.24 2.24zm0-3.49a1.24 1.24 0 101.24 1.25 1.25 1.25 0 00-1.24-1.25zm11.28 1.36A2.24 2.24 0 1123 8.17a2.25 2.25 0 01-2.25 2.25zm0-3.49A1.24 1.24 0 1022 8.17a1.25 1.25 0 00-1.25-1.24zm-4.58 9.67a2.24 2.24 0 112.24-2.24 2.25 2.25 0 01-2.24 2.24zm0-3.49a1.24 1.24 0 101.24 1.25 1.25 1.25 0 00-1.24-1.24z"}}),_c('path',{attrs:{"d":"M5.6 15.22a.5.5 0 01-.36-.85L8.1 11.5a.5.5 0 11.7.7l-2.86 2.88a.5.5 0 01-.36.14zm9.14-1.43a.5.5 0 01-.25-.07l-3.53-2a.5.5 0 11.5-.88l3.53 2.01a.5.5 0 01-.25.94zm2.47-.45a.5.5 0 01-.38-.82l2.59-3.12a.5.5 0 01.77.64l-2.59 3.12a.5.5 0 01-.39.18z"}})])
          )
        }
      }
    